<template>
  <aurora-layout>
    <div class="steps my-10">

      <AppBoxContent v-if="!showBanking && !loading">
        <div class="inside-container-1 w-full sm:w-317 mx-auto">
          <h2 class="text-center text-2xl md:text-4xl">Verify Income</h2>
          <p class="text-center my-4">
            Once your income is verified and approved, you will get funded within 24 hours.
          </p>
        </div>

        <div class="inside-container-2 w-full sm:w-450 mx-auto">
          <div class="inner-container">
            <div class="desired-loan">
              <h3 class="font-semibold text-base py-4">Your desired loan amount</h3>
              <div class="flex justify-between font-semi-bold text-primary text-4xl md:text-7xl">
                <div class="value">{{ loan.amount | money(0) }}</div>
                <div class="currance">USD</div>
              </div>
            </div>
          </div>

          <AppDivider />

          <BoxAction
              @click="handlePlaid()"
              label="Verify"
          />
        </div>
      </AppBoxContent>

      <AppBoxContent v-if="loading" class="flex flex-col">
        <div class="inside-container-1 flex flex-col w-full sm:w-317 mx-auto">
          <h2 class="text-center text-2xl md:text-4xl">Verifying Income</h2>
          <p class="text-center my-4">
            Please wait while we verify your income.
          </p>
        </div>

        <div v-if="proceeding" class="flex flex-grow justify-center items-center">
          <i class="fa fa-circle-notch fa-spin text-3xl"/>
        </div>
      </AppBoxContent>
    </div>
  </aurora-layout>
</template>

<script>
import StepProgress from "../../../components/AuroraStepProgress";
import AppBoxContent from "./../../../../../components/AppBoxContent";
import BoxAction from "../../../components/AuroraBoxAction.vue";
import AppDivider from "../../../../../components/AppDivider.vue";
import AppBankManualModal from "../../../../../components/AppBankManualModal.vue";

export default {
  mixins: [require("../../../../../mixins/InteractsWithGtag").default],

  components: {
    StepProgress,
    AppBoxContent,
    BoxAction,
    AppDivider,
    AppBankManualModal,
  },

  props: {
    user: {},
    loan: {},
    manual: {
      type: Boolean,
      default: false,
    },
    plaidLinkToken: {},
  },

  data() {
    return {
      gTagPageName: "INCOME_VERIFICATION",
      gEventType: "MarketPlaceSignUp",
      showBanking: false,
      showManual: false,
      mx: null,
      plaid: null,
      institution_id: null,
      institution_code: null,
      loading: false,
      proceeding: false,
    };
  },

  methods: {
    refresh() {
      window.location.reload();
    },

    handlePlaid() {
      this.loading = true;
      this.plaid = window.Plaid.create({
        token: this.plaidLinkToken,
        onSuccess: () => {
          this.proceeding = true;

          this.$http.post(`/signup/welcome/${this.loan.id}`, {
            income_verification_submitted: true,
          }).then(() => {
            this.proceeding = false;

            this.proceed();
          }).catch(error => {
            this.proceeding = false;
          })
        },
        onEvent: (event, metadata) => {
            if (event == 'ERROR') {
                window.Bugsnag.notify('fail AuroraIncomeVerification: ' + JSON.stringify({
                  error: metadata.error_code + ' (' + metadata.error_message + ')',
                  loan_id: this.loan?.id,
                  user_id: this.user?.id,
                }));
            }

            this.$http?.post('/api/plaid/link-events', {
                event_name: event,
                loan_id: this.loan?.id ?? null,
                institution_name: metadata.institution_name ?? metadata.institution?.name ?? null,
                error_type: metadata.error_type ?? null,
                error_code: metadata.error_code ?? null,
                error_message: metadata.error_message ?? null,
                link_session_id: metadata.link_session_id ?? null,
                request_id: metadata.request_id ?? null,
                exit_status: metadata.exit_status ?? null,
                metadata: metadata,
                event_time: new Date().toISOString(),
            }).catch(() => {});
        },
        onExit: (error, metadata) => {
          this.loading = false;
        },
      });
      this.plaid.open();
    },

    proceed() {
      this.gTagEvent(`verified`, {
        event_category: 'onboarding',
        event_label: 'income',
      });

      this.proceeding = true;
      window.location.href = `/account/loans/${this.loan.id}`;
    },
  },
};
</script>
